import React, { useEffect, useState } from "react";
import IMGATOM from "../Atoms";
import * as utils from "../../Utils/index";
//import { useTranslation } from 'react-i18next';

const Notifications = (props) => {

    const [list, setlist] = useState([])

    useEffect(() => {
        let tempNotificationList = props.notifications.self.filter(e => (e.state === props.stateName || props.stateName === 'ViewAll'));
        props.notifications.family.forEach(el => {
            el.child.notifications.forEach(e => {
                if (e.state === props.stateName || props.stateName === 'ViewAll') {
                    tempNotificationList.push(e);
                }
            });
        });
        setlist(tempNotificationList);

    }, [props, props.notifications])// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="dashboard-notifications">
            <ul>
                {list && list.length > 0 ? list.map((data, index) => {
                    return (
                        <li key={index}>
                            <IMGATOM
                                alt="notifications"
                                url={data.photoUrl}
                                width="30px"
                            />
                            <span>
                                {data.message}
                                <br/>
                                <label className={`grey-color`}>{utils.timeSince(data.createdOn)}</label>
                            </span>
                        </li>
                    )
                })
                    :
                    <div className="noNotification">
                        {/* {t('no_notifications')} */}
                    </div>
                }
            </ul>
        </div>
    );
}

export default Notifications